module.exports = __webpack_public_path__ + "static/media/cape_new.1cd018a0.gif";